"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  communityFormSizeRanges: true,
  CommunityForm: true
};
exports.CommunityForm = CommunityForm;
exports.communityFormSizeRanges = void 0;
var _Avatar2 = _interopRequireDefault(require("@mui/material/Avatar"));
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _InputAdornment2 = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select2 = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem2 = _interopRequireDefault(require("@mui/material/MenuItem"));
var _InputLabel2 = _interopRequireDefault(require("@mui/material/InputLabel"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _Check2 = _interopRequireDefault(require("@mui/icons-material/Check"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _community_default_banner = _interopRequireDefault(require("../../assets/images/community_default_banner.svg"));
var _form = require("../form");
var _icons = require("../icons");
var _companyFormDialog = require("./company-form-dialog");
Object.keys(_companyFormDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _companyFormDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _companyFormDialog[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const types = [{
  key: 'private',
  titleKey: 'commons.communities.form.types.private',
  Icon: _icons.PeopleIcon
}, {
  key: 'company',
  titleKey: 'commons.communities.form.types.company',
  Icon: _icons.CompanyIcon
}, {
  key: 'association',
  titleKey: 'commons.communities.form.types.association',
  Icon: _icons.AssociationIcon
}, {
  key: 'school',
  titleKey: 'commons.communities.form.types.school',
  Icon: _icons.SchoolIcon
}];
const communityFormSizeRanges = exports.communityFormSizeRanges = {
  company: [],
  school: [{
    key: 'schoolLessThan50',
    max: 50
  }, {
    key: 'schoolBetween50and100',
    min: 51,
    max: 100
  }, {
    key: 'schoolBetween100and500',
    min: 101,
    max: 500
  }, {
    key: 'schoolMoreThan500',
    min: 501
  }],
  association: [{
    key: 'associationLessThan50',
    max: 50
  }, {
    key: 'associationBetween50and100',
    min: 51,
    max: 100
  }, {
    key: 'associationBetween100and500',
    min: 101,
    max: 500
  }, {
    key: 'associationMoreThan500',
    min: 501
  }],
  city: [{
    key: 'cityLessThan30000',
    max: 29_999
  }, {
    key: 'cityBetween30000and70000',
    min: 30_000
  }, {
    key: 'cityBetween70000and300000',
    min: 70_000,
    max: 299_999
  }, {
    key: 'cityMoreThan300000',
    min: 300_000
  }],
  private: [],
  other: []
};
function CommunityForm({
  Button,
  isSubmitting,
  disableType,
  allowedParticipantsTypes,
  geogroup,
  touched,
  values,
  errors,
  icon,
  bannerPicture,
  handleChange,
  setFieldValue,
  setIcon,
  setBannerPicture
}) {
  const [iconPreviewUrl, setIconPreviewUrl] = (0, _react.useState)();
  const [bannerPicturePreviewUrl, setBannerPicturePreviewUrl] = (0, _react.useState)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    if (icon) {
      if (icon instanceof File) setIconPreviewUrl(URL.createObjectURL(icon));else if ('url' in icon) setIconPreviewUrl(icon.url);
    } else {
      setIconPreviewUrl(undefined);
    }
  }, [icon]);
  (0, _react.useEffect)(() => {
    if (bannerPicture) {
      if (bannerPicture instanceof File) setBannerPicturePreviewUrl(URL.createObjectURL(bannerPicture));else if ('url' in bannerPicture) setBannerPicturePreviewUrl(bannerPicture.url);
    } else {
      setBannerPicturePreviewUrl(undefined);
    }
  }, [bannerPicture]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !disableType && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, allowedParticipantsTypes && allowedParticipantsTypes.length === 1 && allowedParticipantsTypes[0] === 'company' ? /*#__PURE__*/_react.default.createElement(_Typography2.default, null, t('commons.communities.form.type_company')) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "h6"
  }, t('commons.communities.form.type')), /*#__PURE__*/_react.default.createElement(_Typography2.default, null, t('commons.communities.form.type_description'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    columnGap: 2,
    display: "flex",
    flexWrap: "wrap",
    rowGap: 1
  }, types.map(({
    key,
    titleKey,
    Icon
  }) => {
    if (key === 'company' && geogroup) return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: key
    });
    const active = values.type === key;
    const disabled = isSubmitting || allowedParticipantsTypes && !allowedParticipantsTypes.includes(key);
    return /*#__PURE__*/_react.default.createElement(Button, {
      color: "inherit",
      disabled: disabled,
      endIcon: active && /*#__PURE__*/_react.default.createElement(_Check2.default, {
        sx: {
          color: '#2AC682'
        }
      }),
      key: key,
      onClick: () => setFieldValue('type', key),
      startIcon: /*#__PURE__*/_react.default.createElement(Icon, {
        color: disabled ? 'action' : 'primary'
      }),
      sx: {
        bgcolor: active ? '#ECFBF4' : undefined,
        borderColor: active ? '#2AC682' : '#DDE0E7',
        color: '#212121'
      },
      variant: "outlined"
    }, t(titleKey));
  }))), values.type && values.type !== 'company' && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "h6"
  }, t('commons.communities.form.data')), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-start",
    display: "flex",
    gap: 8
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    required: true,
    disabled: isSubmitting,
    error: touched.title && Boolean(errors.title),
    label: t('commons.communities.form.name'),
    margin: "none",
    name: "title",
    onChange: handleChange,
    size: "small",
    slotProps: {
      inputLabel: {
        shrink: true
      }
    },
    value: values.title,
    variant: "outlined"
  }), values.type !== 'private' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    required: true,
    disabled: isSubmitting,
    margin: "none",
    size: "small",
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_InputLabel2.default, {
    htmlFor: "size-range-input"
  }, t('commons.communities.form.size_range')), /*#__PURE__*/_react.default.createElement(_Select2.default, {
    inputProps: {
      id: 'size-range-input'
    },
    label: t('commons.communities.form.size_range'),
    name: "sizeRangeIndex",
    onChange: handleChange,
    size: "small",
    value: values.sizeRangeIndex
  }, communityFormSizeRanges[values.type].map(({
    key,
    min,
    max
  }, index) => /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    key: key,
    value: index
  }, t(min !== undefined ? max !== undefined ? 'commons.communities.form.size_ranges.between' : 'commons.communities.form.size_ranges.more_than' : 'commons.communities.form.size_ranges.less_than', {
    context: values.type,
    min,
    max
  }))))), /*#__PURE__*/_react.default.createElement(_form.Autocomplete, {
    required: true,
    defaultValue: values.address,
    disabled: isSubmitting,
    error: touched.address && Boolean(errors.address),
    inputProps: {
      slotProps: {
        inputLabel: {
          shrink: true
        }
      }
    },
    label: t('commons.communities.form.address') || '',
    onSelect: address => setFieldValue('address', address),
    size: "small"
  })), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    multiline: true,
    disabled: isSubmitting,
    error: touched.description && Boolean(errors.description),
    id: "description",
    label: t('commons.communities.form.description'),
    margin: "none",
    name: "description",
    onChange: handleChange,
    rows: 3,
    slotProps: {
      htmlInput: {
        maxLength: 500
      },
      inputLabel: {
        shrink: true
      }
    },
    value: values.description,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: {
      xs: 'column',
      lg: 'row'
    },
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    width: {
      lg: 'calc((100% - 16px) / 2)'
    }
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    disabled: isSubmitting,
    error: touched.linkUrl && Boolean(errors.linkUrl),
    label: t('commons.communities.form.link'),
    margin: "none",
    name: "linkUrl",
    onChange: handleChange,
    size: "small",
    slotProps: {
      input: {
        startAdornment: /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, {
          position: "start"
        }, /*#__PURE__*/_react.default.createElement(_icons.LinkIcon, {
          color: "primary"
        }))
      },
      inputLabel: {
        shrink: true
      }
    },
    type: "url",
    value: values.linkUrl,
    variant: "outlined"
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    width: {
      lg: 'calc((100% - 16px) / 2)'
    }
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    disabled: isSubmitting,
    label: t('commons.communities.form.link_text'),
    margin: "none",
    name: "linkLabel",
    onChange: handleChange,
    size: "small",
    slotProps: {
      inputLabel: {
        shrink: true
      }
    },
    value: values.linkLabel,
    variant: "outlined"
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    marginTop: -1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.logo')), /*#__PURE__*/_react.default.createElement(_form.FileInput, {
    disablePreview: true,
    disabled: isSubmitting,
    file: icon,
    onChange: setIcon,
    size: "small",
    type: "image"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.logo_caption'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    marginTop: -1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.banner')), /*#__PURE__*/_react.default.createElement(_form.FileInput, {
    disablePreview: true,
    disabled: isSubmitting,
    file: bannerPicture,
    onChange: setBannerPicture,
    size: "small",
    type: "image"
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    sx: {
      marginLeft: 2
    },
    variant: "caption"
  }, t('commons.communities.form.banner_caption'))), /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
      checked: values.automaticChallenge,
      disabled: isSubmitting,
      name: "automaticChallenge",
      onChange: handleChange,
      size: "small"
    }),
    label: t('commons.communities.form.automatic_challenges')
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #DDE0E7",
    borderRadius: 4,
    display: {
      xs: 'none',
      md: 'block'
    },
    flexShrink: 0,
    overflow: "hidden",
    width: 360
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    paddingTop: "40%",
    sx: {
      backgroundImage: `url(${bannerPicturePreviewUrl || _community_default_banner.default})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    marginTop: "-48px",
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    src: iconPreviewUrl,
    sx: ({
      palette
    }) => ({
      bgcolor: palette.primary.main,
      border: '1px solid #CFCFCF',
      height: 96,
      width: 96
    })
  }, !iconPreviewUrl ? values.title ? values.title.substring(0, 2) : /*#__PURE__*/_react.default.createElement(_icons.PeopleIcon, {
    fontSize: "large"
  }) : ''), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600,
    variant: "h6"
  }, values.title || t('commons.communities.form.name')), values.description && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, values.description), values.linkUrl && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "primary",
    component: "a",
    href: values.linkUrl,
    target: "_blank",
    variant: "body2"
  }, values.linkLabel || values.linkUrl)), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#EEF9F4",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, t('commons.communities.form.preview_title')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.communities.form.preview_description', {
    geogroupTitle: values.title
  }))))))));
}